import * as React from 'react';
import { connect } from 'react-redux';
import { Card, Image } from 'react-bootstrap';
import { showLinkPolicyModal } from "../../actions/modalActions";
import './LinkPolicy.css';

class LinkPolicy extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.handleLinkPolicy = this.handleLinkPolicy.bind(this);
    }

    handleLinkPolicy(e: any) {
        this.props.showLinkPolicyModal();
    }

    render() {
        return (
            <>
                {this.props.auth.provider !== "anon" &&
                    <>
                        <div className="col-lg-12 pl-0 pb-lg-3 d-none d-lg-block d-md-none container" id="linkPolicyDiv" onClick={this.handleLinkPolicy}>
                            <Card className="tile tileHeight mt-2">
                                <Card.Body>
                                    <div className="column text-center">
                                        <p className="mb-0 link-policy"><Image src="./Images/icon-link-policy-nugreen-32px-32px.svg" className="mr-3 img-fit" /><b>    Link my policy</b></p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                        <div className="d-block d-lg-none d-md-block" id="linkPolicyDivMobile" onClick={this.handleLinkPolicy}>
                            <Card className="tile-mobile cursor-pointer">
                                <Card.Body>
                                    <div className="column text-center">
                                        <p className="mb-0 link-policy"><Image src="./Images/icon-link-policy-nugreen-32px-32px.svg" className="mr-3 img-fit" /><b>    Link my policy</b></p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </>
                }
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        auth: state.auth
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        showLinkPolicyModal: () => dispatch(showLinkPolicyModal()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LinkPolicy);
